import _ from 'lodash'

export default {
  getFormData (e) {
    if (e.type !== 'submit') throw new Error('not a submit event')

    const elements = e.currentTarget ? e.currentTarget.elements : e.srcElement.elements
    const formData = new FormData()
    _.each(
      elements,
      dom => {
        switch (dom.type) {
          case 'hidden':
            formData.append(dom.name, dom.value)
            break
          case 'text':
          case 'textarea':
            formData.append(dom.id, dom.value)
            break
          case 'file':
            _.forEach(
              dom.files,
              file => formData.append(dom.id, file)
            )
            break
        }
      }
    )
    return formData
  },

  getJsonFormData (formData) {
    if (!formData) return undefined

    const obj = {}
    for (const pair of formData.entries()) {
      const key = pair[0]
      const value = pair[1]
      obj[key] = value
    }

    return JSON.stringify(obj)
  }
}



// WEBPACK FOOTER //
// ./src/utils/form.js